import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Feather from 'react-feather';

import { Popover, ArrowContainer } from 'react-tiny-popover';

import { Label } from 'reactstrap';
import { matchPath, Link } from 'react-router-dom';

import NavBadge from './NavBadge';


const NavSingleItem = ({ item, branding, isChild, shadeColor, location, company, stripeDataFetched }) => {
  const Icon = item.icon && Feather[item.icon] ? Feather[item.icon] : null;

  const [hoverActive, setHoverActive] = React.useState(false);

  const { subscriptionSetup } = company;

  const [isOpen, setIsOpen] = useState(true);

  const toggleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsOpen(false);
  } 

  if (item.external) {
    const rel = item.target && item.target === '_blank' ? 'noopener noreferrer' : null;

    return (
      <li
        className="nav-item"
        onMouseEnter={() => setHoverActive(true)}
        onMouseLeave={() => setHoverActive(false)}
      >
        <a href={item.url} target={item.target} rel={rel}>
          {item.icon && Icon && <Icon className="side-nav-icon" />}
          <span className="nav-item-label">{item.name}</span>
          {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
        </a>
      </li>
    );
  } else {
    // Force relative URLs to start with a slash
    const url = item.url.charAt(0) === '/' ? item.url : `/${item.url}`;

    let isActive = false;
    if (location === item.url) {
      isActive = true;
    }

    let bgColor2 = '#0b1628';

    console.log('isActive', isActive, company);

    if (branding.sidebarPrimaryColor) {
      bgColor2 = branding.sidebarPrimaryColor;
    }

    let bgColor = '#ff6a00';

    if (!subscriptionSetup && stripeDataFetched) {
      return (
        <>
          <Popover
            positions={['right']}
            padding={10}
            isOpen={isOpen}
            onClick={(e) => toggleClose(e)}
            content={({ position, childRect, popoverRect }) => (
              <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={'#14c2ff'}
                arrowSize={6}
                arrowStyle={{ opacity: 0.9 }}
              >
                <div
                  style={{
                    backgroundColor: '#14c2ff',
                    color: '#FFF',
                    opacity: 0.9,
                    padding: 3,
                    paddingTop: 2,
                    paddingRight: 15,
                    paddingLeft: 15,
                    borderRadius: 2,
                    fontFamily: 'system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
                    fontSize: 15,
                  }}
                  onClick={(e) => toggleClose(e)}
                >
                  <div style={{ display: 'inline-block', paddingRight: 3 }}>View your plan </div>
                  <div style={{ cursor: 'pointer', fontWeight: 900, display: 'inline-block', color: '#FFF' }}>{'\uD83D\uDDD9'}</div>
                </div>
              </ArrowContainer>
            )}
          >

            <li className={`nav-item nav-item-withCounter`} style={{ backgroundColor: bgColor2, lineHeight: '28px' }}>
              <NavLink
                to={url}
                style={{
                  color: branding.sidebarTextColor,
                  background: (isActive || hoverActive) ? shadeColor(bgColor, 20) : bgColor,
                  borderRadius: 16,
                }}
                activeClassName="active"
                onMouseEnter={() => setHoverActive(true)}
                onMouseLeave={() => setHoverActive(false)}
              >
                {item.icon && Icon && <Icon className="side-nav-icon" />}
                <span className="nav-item-label" style={{ textTransform: 'capitalize' }}>{`Your plan: ${(company && company.subcriptionType && company.subscriptionActive) ? company.subcriptionType : 'Free'}`}</span>
                {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
              </NavLink>
            </li>
          </Popover>
        </>
      );
    }

    return (
      <li className="nav-item">
        <NavLink
          to={url}
          style={{
            color: branding.sidebarTextColor,
            background: (isActive || hoverActive) ? shadeColor(bgColor2, 20) : bgColor2,
            borderRadius: 16,
          }}
          activeClassName="active"
          onMouseEnter={() => setHoverActive(true)}
          onMouseLeave={() => setHoverActive(false)}
        >
          {item.icon && Icon && <Icon className="side-nav-icon" />}
          <span className="nav-item-label" style={{ textTransform: 'capitalize' }}>{`Your plan: ${(company && company.subcriptionType && company.subscriptionActive) ? company.subcriptionType : 'Free'}`}</span>
          {item.badge && <NavBadge color={item.badge.variant} text={item.badge.text} />}
        </NavLink>
      </li>
    );
  }
};

export default NavSingleItem;
